<template>
  <footer id="footer" class="footer dark-background" v-if="footer">
    <div class="container footer-top">
      <div class="row gy-4">
        <div class="col-lg-4 col-md-6 footer-about">
          <a href="index.html" class="logo d-flex align-items-center">
            <!-- <span class="sitename">Sailor</span> -->
            <img v-if="footer.logo" :src="footer.logo.url" />
          </a>
          <div class="pt-3">
            <span v-html="footer.bloco01" />
          </div>
          <div class="social-links d-flex mt-4">
            <a href="#" v-for="(midia, i) in midiaSocial" :key="i"
              ><i :class="`bi bi-${midia.tipo}`"></i
            ></a>
            <!-- <a href=""><i class="bi bi-facebook"></i></a>
            <a href=""><i class="bi bi-instagram"></i></a>
            <a href=""><i class="bi bi-linkedin"></i></a> -->
          </div>
        </div>

        <div class="col-lg-2 col-md-3 footer-links">
          <!-- <h4>Useful Links</h4>
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">About us</a></li>
            <li><a href="#">Services</a></li>
            <li><a href="#">Terms of service</a></li>
            <li><a href="#">Privacy policy</a></li>
          </ul> -->
        </div>

        <div class="col-lg-2 col-md-3 footer-links">
          <!-- <h4>Our Services</h4>
          <ul>
            <li><a href="#">Web Design</a></li>
            <li><a href="#">Web Development</a></li>
            <li><a href="#">Product Management</a></li>
            <li><a href="#">Marketing</a></li>
            <li><a href="#">Graphic Design</a></li>
          </ul> -->
        </div>

        <!-- <div class="col-lg-4 col-md-12 footer-newsletter">
          <h4>Our Newsletter</h4>
          <p>
            Subscribe to our newsletter and receive the latest news about our
            products and services!
          </p>
        </div> -->
      </div>
    </div>

    <div class="container copyright text-center mt-4">
      <!-- <p>
        © <span>Copyright</span> <strong class="px-1 sitename">Sailor</strong>
        <span>All Rights Reserved</span>
      </p> -->
    </div>

    <span
      v-if="whatsapp"
      :href="`https://wa.me/${whatsapp.endereco}`"
      target="_blank"
      class="whatsapp-button"
      style="cursor: pointer"
      @click="openWhatsapp(whatsapp)"
    >
      <span
        style="
          background-color: #e0e0e0;
          color: #0f0f0f;
          padding: 10px;
          padding-right: 15px;
          border-radius: 10px;
          font-size: 16px;
          margin-right: -8px;
        "
        >{{ whatsapp.titulo }}</span
      >
      <img
        src="https://play-lh.googleusercontent.com/bYtqbOcTYOlgc6gqZ2rwb8lptHuwlNE75zYJu6Bn076-hTmvd96HH-6v7S0YUAAJXoJN"
        alt="WhatsApp"
      />
    </span>
  </footer>
</template>

<script>
import { onMounted, reactive, ref, toRefs } from "vue";
import { FooterService } from "./footer.service";

export default {
  name: "ComponentFooter",
  components: {},
  setup() {
    const $serviceFooter = new FooterService();

    const data = reactive({
      footer: ref(),
      midiaSocial: ref(),
      whatsapp: ref(),
    });

    onMounted(async () => {
      await findFooter();
      await findMidiaSocial();
    });

    async function findFooter() {
      const response = await $serviceFooter.findFooter();
      data.footer = response.data;
    }

    async function findMidiaSocial() {
      const response = await $serviceFooter.findMidiaSocial();
      data.midiaSocial = response.data.filter(
        (midia) => midia.tipo != "whatsapp"
      );
      data.whatsapp = response.data.find((midia) => midia.tipo == "whatsapp");
    }

    function openWhatsapp(whatsapp) {
      window.open(
        `https://wa.me/${whatsapp.endereco}?text=${whatsapp.mensagem}`,
        "_blank"
      );
    }

    return {
      ...toRefs(data),
      openWhatsapp,
    };
  },
};
</script>

<style scoped>
.whatsapp-button {
  position: fixed;
  bottom: 95px;
  right: 20px;
  z-index: 9999;
}

.whatsapp-button img {
  width: 60px;
  height: 60px;
  border-radius: 10%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s;
}

.whatsapp-button img:hover {
  transform: scale(1.1);
}
</style>
